import axios from 'axios';

// Direct access to Cloud Run
const DIRECT_API_URL = 'https://assemblie-337625316098.us-east1.run.app';
const API_GATEWAY_KEY = process.env.REACT_APP_API_GATEWAY_KEY || 'YOUR_API_KEY';

const directApiClient = axios.create({
	baseURL: DIRECT_API_URL,
	timeout: 10000,
});

// Add request interceptor to add token to all requests
directApiClient.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers.Authorization = token.startsWith('Bearer ')
				? token
				: `Bearer ${token}`;
		}

		// Add API key for endpoints that might need it
		if (config.url.includes('api/gateway')) {
			// Add the API key as a query parameter for gateway-related endpoints
			config.params = { ...config.params, key: API_GATEWAY_KEY };
		}

		return config;
	},
	(error) => Promise.reject(error)
);

// Add response interceptor for debugging
directApiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		console.error(
			'Direct API error:',
			error.response?.status,
			error.response?.data
		);
		return Promise.reject(error);
	}
);

export default directApiClient;
